import styled from "styled-components";

const Separator = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.base2};
`;

export default Separator;
